import ImagePlus from '@/component/message/pic/component/image-plus/index.vue';
import { defineComponent, inject, PropType } from 'vue';
import { ImageInfo, PicInfo } from '_c/typings/proto';
import { IMsg, SendStatusType } from '_c/typings/model/im';
import EventBus from '_c/util/event-bus';
import { ChatPageEvents, ChatPageEventType } from '_c/typings/event/global';

export interface RealImageInfo extends ImageInfo {
  realWidth: number,
  realHeight: number,
}

interface PicMessageViewData {
  imageList: Array<RealImageInfo>,
}

export default defineComponent({
  name: 'PicMessageView',
  components: {
    ImagePlus,
  },
  props: {
    picInfo: {
      type: Array as PropType<Array<PicInfo>>,
      required: true,
      default: () => [],
    },
  },
  setup(): {
    messageData: IMsg
    chatPageEventBus: EventBus<ChatPageEvents> | null,
  } {
    return {
      messageData: inject('messageData') as IMsg,
      chatPageEventBus: inject<EventBus<ChatPageEvents> | null>('chatPageEventBus', null),
    };
  },
  data(): PicMessageViewData {
    return {
      imageList: [],
    };
  },
  computed: {
    isUploading() {
      const { sendStatus } = this.messageData;
      return sendStatus === SendStatusType.preHandle;
    },
  },
  created(): void {
    const tempList: Array<RealImageInfo> = [];
    this.picInfo.forEach((item) => {
      item.imageInfoArray.forEach((subItem) => {
        tempList.push(this.generateRealImage(subItem));
      });
    });
    this.imageList = tempList;
  },
  methods: {
    /**
     * 生成真实图片参数
     * PC单独适配与h5不一样，主要区别是在最小值和最大值展示展示尺寸
     * @param imgInfo
     */
    generateRealImage(imgInfo: ImageInfo): RealImageInfo {
      const MAX_IMAGE_WIDTH = 380;
      const MAX_IMAGE_HEIGHT = 300;
      const MIN_IMAGE_WIDTH = 60;
      const MIN_IMAGE_HEIGHT = 60;

      const { width, height } = imgInfo;
      const { max } = Math;

      let calWidth = 0.0;
      let calHeight = 0.0;

      if (!height || !width) {
        // 如果照片的宽度和高度有一个异常,
        calWidth = MAX_IMAGE_WIDTH;
        calHeight = calWidth;
      } else if (width / height < 0.7) {
        // 长图,高度容器已固定，宽度自适应,确定容器大小
        // 分为小长图和大长图
        if (height < MIN_IMAGE_HEIGHT) {
          calHeight = MIN_IMAGE_HEIGHT;
          calWidth = max(MIN_IMAGE_WIDTH, width / (height / MAX_IMAGE_HEIGHT));
        } else if (height > MAX_IMAGE_HEIGHT) {
          calHeight = MAX_IMAGE_HEIGHT;
          calWidth = max(MIN_IMAGE_WIDTH, width / (height / MAX_IMAGE_HEIGHT));
        } else {
          calHeight = height;
          calWidth = width;
        }
      } else if (width / height > 1.2) {
        // 宽图
        if (width < MIN_IMAGE_WIDTH) {
          calWidth = MIN_IMAGE_WIDTH;
          calHeight = max(MIN_IMAGE_HEIGHT, height / (width / MAX_IMAGE_WIDTH));
        } else if (width > MAX_IMAGE_WIDTH) {
          calWidth = MAX_IMAGE_WIDTH;
          calHeight = max(MIN_IMAGE_HEIGHT, height / (width / MAX_IMAGE_WIDTH));
        } else {
          calWidth = width;
          calHeight = height;
        }
      } else {
        // 方图
        if (width < MIN_IMAGE_WIDTH) {
          calWidth = MIN_IMAGE_WIDTH;
          calHeight = MIN_IMAGE_WIDTH;
        } else if (width > MAX_IMAGE_WIDTH) {
          calWidth = MAX_IMAGE_WIDTH;
          calHeight = MAX_IMAGE_WIDTH;
        } else {
          calWidth = width;
          calHeight = height;
        }
      }
      return Object.assign({}, imgInfo, {
        realWidth: calWidth,
        realHeight: calHeight,
      });
    },
    /**
     * 点击回调
     */
    onClickImageHandler(imgInfo: RealImageInfo): void {
      if (this.messageData.sendStatus === SendStatusType.success) {
        this.chatPageEventBus?.emit(ChatPageEventType.pictureClick, {
          messageInfo: this.messageData,
          imageInfo: imgInfo,
        });
      }
    },
  },
});
